/** Solutions flow UI — keep keys in sync across fi / en / sv */

export const solutionComponentsFi = {
  listView: {
    backToPivots: 'Vipupisteet',
    pageTitle: 'Ratkaisut',
    addSolution: 'Lisää ratkaisu',
    pivotTag: 'Vipupiste',
    emptyTitle: 'Ei lisättyjä ratkaisuja',
    emptyHint: 'Aloita lisäämällä ensimmäinen ratkaisu.',
    editTitleTooltip: 'Muokkaa otsikkoa',
    phaseWrite: 'Kirjoita',
    phaseCoverage: 'Esteet',
    phaseDone: 'Valmis',
    stateAnalysing: 'Analysoidaan…',
    stateReady: 'Valmis',
    ownBadge: 'Oma',
    doneLabel: 'Valmis',
    solutionGroupCountOne: '{{count}} ratkaisu',
    solutionGroupCountMany: '{{count}} ratkaisua',
    viewByPivot: 'Vipupisteittäin',
    viewVotingResults: 'Äänestystulokset',
    signInToVote: 'Kirjaudu sisään äänestääksesi ratkaisuja. Äänimäärät näkyvät kaikille.',
    vote: 'Äänestä',
    removeVote: 'Poista ääni',
    signInToVoteTitle: 'Kirjaudu äänestääksesi',
    otherSolutions: 'Muut ratkaisut',
    orphanDescOne: '{{count}} ratkaisu ilman valittua vipupistettä',
    orphanDescMany: '{{count}} ratkaisua ilman valittua vipupistettä',
  },
  screen: {
    navPivots: 'Vipupisteet',
    navSolutions: 'Ratkaisut',
    navOverview: 'Yhteenveto',
    allSolutions: 'Kaikki ratkaisut',
    loading: 'Ladataan ratkaisudataa...',
    errorLoading: 'Virhe datan latauksessa',
    noInstance: 'Ei instanssia valittuna. Lisää ?kid= tai ?instance= URL-parametri.',
  },
  common: {
    cancel: 'Peruuta',
    delete: 'Poista',
    confirmDelete: 'Kyllä, poista',
    deleting: 'Poistetaan...',
    close: 'Sulje',
    save: 'Tallenna',
    edit: 'Muokkaa',
    continue: 'Jatka →',
    saving: 'Tallennetaan...',
    doneArrow: 'Valmis →',
    solution: 'Ratkaisu',
  },
  write: {
    placeholder: 'Kirjoita ratkaisuehdotus...',
    enrichDone: 'Teksti rikastettu!',
    enrichTooltip: 'Rikasta teksti AI:lla',
    reEnrichTooltip: 'Korvaa nykyisen AI-tekstin',
    enrichBtn: 'AI-rikasta',
    reEnrichBtn: 'Luo uudelleen',
    enrichMessages: [
      'Haetaan tutkimustietoa...',
      'Analysoidaan ratkaisua...',
      'Rikastetaan tekstiä...',
      'Viimeistellään...',
    ],
    matchingMessages: [
      'Tallennetaan ratkaisua...',
      'Kartoitetaan esteitä ja mahdollisuuksia...',
      'AI tunnistaa, mihin kohtiin ratkaisusi vastaa...',
    ],
  },
  coverage: {
    noLensItems:
      'Tähän vipupisteeseen ei ole vielä lisätty esteitä tai mahdollisuuksia. Voit jatkaa suoraan AI-analyysiin.',
    matchingStatus: 'Kartoitetaan esteitä ja mahdollisuuksia…',
    matchingDone: 'Peitto tarkistettu!',
    matchingMessages: [
      'Tarkistetaan linssipeittoa...',
      'Tunnistetaan esteitä ja mahdollisuuksia...',
    ],
    analysisMessages: [
      'Tallennetaan ratkaisua...',
      'Haetaan tutkimustietoa...',
      'Arvioidaan vaikuttavuutta...',
      'Arvioidaan toteutettavuutta...',
      'Arvioidaan innovatiivisuutta...',
      'Tarkistetaan tutkimusnäyttöä...',
      'Laaditaan SWOT-analyysia...',
      'Analysoidaan linssivaikutuksia...',
      'Viimeistellään kokonaisarviota...',
      'Melkein valmis — tarkistetaan vielä...',
      'Hiotaan viimeisiä yksityiskohtia...',
    ],
    estimatedTime: '20–60 sekuntia',
    openBlockers: 'Avoimet esteet',
    solutionCovers: 'Ratkaisu kattaa',
    groupHandled: 'Ryhmän käsittelemät',
    itemsCount: '{{count}} kohtaa',
    notePlaceholder: 'Miten ratkaisunne voisi huomioida tämän?',
    obstacleTag: 'este',
    opportunityTag: 'mahdollisuus',
    sufficientTag: 'riittävä',
    insufficientTag: 'riittämätön',
    groupNotePrefix: 'Ryhmä:',
    aiPrefix: 'AI:',
  },
  done: {
    obstaclesOpportunities: 'Esteet & mahdollisuudet',
    disclaimer:
      'AI-analyysi perustuu tutkimustietokantaan ja kielimalliin. Se ei korvaa asiantuntijuuttasi.',
    confirmDeletePublished:
      'Ratkaisu on jo analysoitu ja julkaistu. Haluatko varmasti poistaa sen?',
    reanalyze: 'Analysoi uudelleen',
    aiWorking: 'AI työstää…',
    analysisMessages: [
      'Tallennetaan ratkaisua...',
      'Haetaan tutkimustietoa...',
      'Verrataan tutkimuslähteisiin...',
      'Tunnistetaan ratkaisun tunnisteita...',
      'Laaditaan SWOT-analyysia...',
      'Tunnistetaan vahvuudet...',
      'Tunnistetaan kehityskohteet...',
      'Analysoidaan linssivaikutuksia...',
      'Arvioidaan esteiden kattavuutta...',
      'Kirjoitetaan kokonaisarviota...',
      'Tarkistetaan viittaukset...',
      'Viimeistellään analyysia...',
      'Kootaan tuloksia yhteen...',
      'Melkein valmis — tarkistetaan vielä...',
      'Hiotaan viimeisiä yksityiskohtia...',
    ],
    estimatedTime: '1–2 minuuttia',
  },
  stepper: {
    write: 'Kirjoita ratkaisu',
    coverage: 'Esteet & mahdollisuudet',
    done: 'AI-analyysi',
    info: {
      write:
        'Kirjoita ratkaisuehdotuksesi omin sanoin. Kun olet valmis, voit pyytää AI:ta rikastamaan tekstiä tutkimustiedolla. Tämän vaiheen jälkeen punnitsemme esteitä ja mahdollisuuksia.',
      write_enriching:
        'AI rikastaa tekstiäsi tutkimustiedolla. Voit jatkaa kirjoittamista tai siirtyä seuraavaan vaiheeseen.',
      write_enriched:
        'Teksti rikastettu! Tarkista muutokset — sinun tekstisi on sinisellä, AI:n lisäykset valkoisella.',
      coverage:
        'Tarkista, miten ratkaisusi vastaa tunnistettuihin esteisiin ja mahdollisuuksiin. Voit kirjoittaa vastauksen avoimiin kohtiin.',
      coverage_enriching:
        'AI-rikastus on vielä käynnissä. Esteet ja mahdollisuudet perustuvat alkuperäiseen tekstiin.',
      coverage_matching: 'AI tarkistaa, mihin esteisiin ja mahdollisuuksiin ratkaisusi vastaa...',
      done_analyzing: 'AI analysoi ratkaisuasi — analyysi ilmestyy tähän kun se on valmis.',
      done: 'Ratkaisusi on valmis ja analysoitu.',
    },
  },
  intro: {
    title: 'Ratkaisun luominen',
    bodyWithPivotBefore: 'Luot ratkaisuehdotuksen vipupisteeseen ',
    bodyWithPivotAfter: '. Prosessissa on kolme vaihetta:',
    bodyNoPivot: 'Luot ratkaisuehdotuksen. Prosessissa on kolme vaihetta:',
    bodyWithPivotAfter2: '. Prosessissa on kaksi vaihetta:',
    bodyNoPivot2: 'Luot ratkaisuehdotuksen. Prosessissa on kaksi vaihetta:',
    start: 'Aloita',
    step1Title: 'Kirjoita ratkaisuehdotus',
    step1Desc:
      'Kuvaa ratkaisusi omin sanoin. Ei tarvitse olla täydellinen — tärkeintä on ydinajatus.',
    step1Ai: 'AI voi rikastaa tekstiäsi tutkimustiedolla',
    step2Title: 'Esteet & mahdollisuudet',
    step2Desc:
      'Tarkista, miten ratkaisusi vastaa tunnistettuihin esteisiin ja mahdollisuuksiin. Voit kirjoittaa lyhyen vastauksen avoimiin kohtiin.',
    step2Ai: 'AI tunnistaa, mihin kohtiin ratkaisusi vastaa',
    step3Title: 'Valmis',
    step3Desc: 'Ratkaisusi tallennetaan ja näet tulokset kun ne ovat valmiita.',
    step3Ai: 'AI analysoi ratkaisusi taustalla',
  },
  analysisLoader: {
    title: 'AI analysoi ratkaisuasi',
    closeTitle: 'Sulje — analyysi jatkuu taustalla',
    closeAndNew: 'Sulje ja lisää uusi ratkaisu',
    closeHint: 'Analyysi jatkuu taustalla — tulos ilmestyy listaan.',
    closeBackground: 'Sulje — analyysi jatkuu taustalla',
    starting: 'Aloitetaan...',
    estimatedPrefix: 'Arvioitu kesto: {{time}}',
    warmSubtitles: [
      'Tämä kestää hetken — hyvä hetki venytellä.',
      'AI lukee tutkimuksia ja arvioi ratkaisuasi.',
      'Kahvitauon paikka — palataan tuloksiin kohta.',
      'Tekoäly käy läpi tutkimustietokantaa.',
      'Hyvä hetki vilkaista ikkunasta ulos.',
      'Analyysi on käynnissä — ei hätää, kaikki etenee.',
      'AI vertailee ratkaisuasi aiempiin tutkimustuloksiin.',
      'Pieni tauko tekee hyvää — me hoidamme tämän.',
      'Etsitään vahvuuksia ja kehityskohteita.',
      'Tutkimustietokannan läpikäynti vie hetken.',
      'Kohta näet tulokset — analyysi etenee hyvin.',
      'Tekoäly punnitsee eri näkökulmia.',
      'Hyvä ratkaisu ansaitsee huolellisen arvioinnin.',
      'AI käy läpi esteet, mahdollisuudet ja linssit.',
      'Melkein valmista — viimeistellään arviota.',
      'Tutkimuslähteet käyty läpi, kootaan tuloksia.',
      'Tee pieni venyttely — tulokset ovat kohta valmiit.',
      'AI kirjoittaa SWOT-analyysia ratkaisustasi.',
      'Kärsivällisyys palkitaan — tulossa kattava arvio.',
      'Viimeistelyvaihe — kohta valmista!',
    ],
  },
  sourceLabels: {
    writeLabel: 'Kirjoita ratkaisu',
    yourSolution: 'Ratkaisusi',
    aiEnhanced: 'AI-parannettu',
    humanPercent: '{{percent}}% ihminen',
  },
  modal: {
    bgEnriching: 'AI rikastaa ratkaisua...',
    bgAnalyzing: 'AI analysoi ratkaisua...',
    matchFailedHttp: 'Kartoitus epäonnistui (HTTP {{status}})',
    matchEmpty: 'Kartoitus palautti tyhjän vastauksen',
    matchFailed:
      'Esteiden ja mahdollisuuksien kartoitus epäonnistui: {{message}}. Voit yrittää uudelleen tai jatkaa ilman kattavuusarviota.',
    deleteFailed: 'Poisto epäonnistui',
    saveFailed: 'Tallennus epäonnistui',
    saveFailedGeneric: 'Tallennus epäonnistui',
    matchIdentifyFailed:
      'Esteiden ja mahdollisuuksien tunnistus epäonnistui. Voit jatkaa ilman kattavuusarviota.',
    analysisFailed:
      'AI-analyysi epäonnistui: {{message}}. Voit jatkaa ilman analyysia tai yrittää uudelleen.',
    unknownError: 'Tuntematon virhe',
    publishFailed: 'Julkaisu epäonnistui',
    enrichFailed: 'AI-rikastus epäonnistui',
    reanalyzeFailed:
      'Uudelleenanalyysi epäonnistui: {{message}}. Voit jatkaa ilman analyysia.',
    reanalyzeFailedGeneric: 'Uudelleenanalyysi epäonnistui',
  },
  startView: {
    title: 'Ratkaisujen aika',
    subtitle:
      'Olette tutkineet tulevaisuuskuvia, rakentaneet vaikutuspolkuja, tunnistaneet vipupisteitä ja analysoineet esteitä ja mahdollisuuksia. Nyt on aika luoda konkreettisia ratkaisuja.',
    labelPivot: 'vipupistettä',
    labelObstacle: 'estettä',
    labelOpportunity: 'mahdollisuutta',
    nextCardTitle: 'Luodaan ratkaisut',
    nextCardSubtitle: 'Valitse vipupiste ja kirjoita ratkaisuehdotus',
    cta: 'Aloitetaan!',
  },
  pivotSelect: {
    pageTitle: 'Valitse vipupiste',
    helperText: 'Valitse vipupiste, jolle haluat luoda ratkaisuehdotuksia.',
    emptyState: 'Ei vipupisteitä. Luo vipupisteet ensin Linssit-vaiheessa.',
    unnamed: 'Nimetön',
    solutionSingular: '{{count}} ratkaisu',
    solutionPlural: '{{count}} ratkaisua',
    votes: 'Tärkeä · {{count}} tiimiä',
  },
};

export const solutionComponentsEn = {
  listView: {
    backToPivots: 'Pivot points',
    pageTitle: 'Solutions',
    addSolution: 'Add solution',
    pivotTag: 'Pivot point',
    emptyTitle: 'No solutions yet',
    emptyHint: 'Get started by adding the first solution.',
    editTitleTooltip: 'Edit title',
    phaseWrite: 'Write',
    phaseCoverage: 'Obstacles',
    phaseDone: 'Done',
    stateAnalysing: 'Analyzing…',
    stateReady: 'Done',
    ownBadge: 'Mine',
    doneLabel: 'Done',
    solutionGroupCountOne: '{{count}} solution',
    solutionGroupCountMany: '{{count}} solutions',
    viewByPivot: 'By pivot point',
    viewVotingResults: 'Voting results',
    signInToVote: 'Sign in to vote on solutions. Vote counts are visible to everyone.',
    vote: 'Vote',
    removeVote: 'Remove vote',
    signInToVoteTitle: 'Sign in to vote',
    otherSolutions: 'Other solutions',
    orphanDescOne: '{{count}} solution without a selected pivot point',
    orphanDescMany: '{{count}} solutions without a selected pivot point',
  },
  screen: {
    navPivots: 'Pivot points',
    navSolutions: 'Solutions',
    navOverview: 'Overview',
    allSolutions: 'All solutions',
    loading: 'Loading solution data...',
    errorLoading: 'Error loading data',
    noInstance: 'No instance selected. Add a ?kid= or ?instance= URL parameter.',
  },
  common: {
    cancel: 'Cancel',
    delete: 'Delete',
    confirmDelete: 'Yes, delete',
    deleting: 'Deleting...',
    close: 'Close',
    save: 'Save',
    edit: 'Edit',
    continue: 'Continue →',
    saving: 'Saving...',
    doneArrow: 'Done →',
    solution: 'Solution',
  },
  write: {
    placeholder: 'Write a solution proposal...',
    enrichDone: 'Text enriched!',
    enrichTooltip: 'Enrich text with AI',
    reEnrichTooltip: 'Replace current AI text',
    enrichBtn: 'AI enrich',
    reEnrichBtn: 'Regenerate',
    enrichMessages: [
      'Fetching research...',
      'Analyzing solution...',
      'Enriching text...',
      'Finishing up...',
    ],
    matchingMessages: [
      'Saving solution...',
      'Mapping obstacles and opportunities...',
      'AI is identifying which points your solution addresses...',
    ],
  },
  coverage: {
    noLensItems:
      'No obstacles or opportunities have been added for this pivot point yet. You can continue straight to AI analysis.',
    matchingStatus: 'Mapping obstacles and opportunities…',
    matchingDone: 'Coverage checked!',
    matchingMessages: [
      'Checking lens coverage...',
      'Identifying obstacles and opportunities...',
    ],
    analysisMessages: [
      'Saving solution...',
      'Fetching research...',
      'Assessing impact...',
      'Assessing feasibility...',
      'Assessing innovativeness...',
      'Checking research evidence...',
      'Drafting SWOT analysis...',
      'Analyzing lens effects...',
      'Finalizing overall assessment...',
      'Almost done — one more check...',
      'Polishing the last details...',
    ],
    estimatedTime: '20–60 seconds',
    openBlockers: 'Open obstacles',
    solutionCovers: 'Solution covers',
    groupHandled: 'Addressed by the group',
    itemsCount: '{{count}} items',
    notePlaceholder: 'How could your solution take this into account?',
    obstacleTag: 'obstacle',
    opportunityTag: 'opportunity',
    sufficientTag: 'sufficient',
    insufficientTag: 'insufficient',
    groupNotePrefix: 'Group:',
    aiPrefix: 'AI:',
  },
  done: {
    obstaclesOpportunities: 'Obstacles & opportunities',
    disclaimer:
      'AI analysis is based on the research database and a language model. It does not replace your expertise.',
    confirmDeletePublished:
      'This solution has already been analyzed and published. Are you sure you want to delete it?',
    reanalyze: 'Analyze again',
    aiWorking: 'AI is working…',
    analysisMessages: [
      'Saving solution...',
      'Fetching research...',
      'Comparing research sources...',
      'Identifying solution tags...',
      'Drafting SWOT analysis...',
      'Identifying strengths...',
      'Identifying development areas...',
      'Analyzing lens effects...',
      'Assessing obstacle coverage...',
      'Writing overall assessment...',
      'Checking citations...',
      'Finalizing analysis...',
      'Putting results together...',
      'Almost done — one more check...',
      'Polishing the last details...',
    ],
    estimatedTime: '1–2 minutes',
  },
  stepper: {
    write: 'Write solution',
    coverage: 'Obstacles & opportunities',
    done: 'AI analysis',
    info: {
      write:
        'Write your solution proposal in your own words. When you are ready, you can ask AI to enrich the text with research. After this step we weigh obstacles and opportunities.',
      write_enriching:
        'AI is enriching your text with research. You can keep writing or move to the next step.',
      write_enriched:
        'Text enriched! Review the changes — your text is in blue, AI additions in white.',
      coverage:
        'Check how your solution addresses the identified obstacles and opportunities. You can write a response for open items.',
      coverage_enriching:
        'AI enrichment is still running. Obstacles and opportunities are based on the original text.',
      coverage_matching: 'AI is checking which obstacles and opportunities your solution addresses...',
      done_analyzing: 'AI is analyzing your solution — the analysis will appear here when ready.',
      done: 'Your solution is ready and analyzed.',
    },
  },
  intro: {
    title: 'Creating a solution',
    bodyWithPivotBefore: 'You are creating a solution proposal for pivot point ',
    bodyWithPivotAfter: '. The process has three steps:',
    bodyNoPivot: 'You are creating a solution proposal. The process has three steps:',
    bodyWithPivotAfter2: '. The process has two steps:',
    bodyNoPivot2: 'You are creating a solution proposal. The process has two steps:',
    start: 'Start',
    step1Title: 'Write a solution proposal',
    step1Desc:
      'Describe your solution in your own words. It does not need to be perfect — the core idea matters most.',
    step1Ai: 'AI can enrich your text with research',
    step2Title: 'Obstacles & opportunities',
    step2Desc:
      'Check how your solution addresses the identified obstacles and opportunities. You can write a short response for open items.',
    step2Ai: 'AI identifies which points your solution addresses',
    step3Title: 'Done',
    step3Desc: 'Your solution is saved and you will see the results when they are ready.',
    step3Ai: 'AI analyzes your solution in the background',
  },
  analysisLoader: {
    title: 'AI is analyzing your solution',
    closeTitle: 'Close — analysis continues in the background',
    closeAndNew: 'Close and add a new solution',
    closeHint: 'Analysis continues in the background — the result appears in the list.',
    closeBackground: 'Close — analysis continues in the background',
    starting: 'Starting...',
    estimatedPrefix: 'Estimated time: {{time}}',
    warmSubtitles: [
      'This takes a moment — a good time to stretch.',
      'AI is reading research and assessing your solution.',
      'Coffee break time — we will be back with results soon.',
      'The AI is going through the research database.',
      'A good moment to glance out the window.',
      'Analysis is running — no worries, everything is progressing.',
      'AI is comparing your solution with earlier research findings.',
      'A short break is good — we have got this.',
      'Looking for strengths and development areas.',
      'Going through the research database takes a moment.',
      'Results coming soon — analysis is progressing well.',
      'The AI is weighing different perspectives.',
      'A good solution deserves a careful review.',
      'AI is reviewing obstacles, opportunities, and lenses.',
      'Almost ready — finishing the assessment.',
      'Research sources reviewed, compiling results.',
      'Do a quick stretch — results are almost ready.',
      'AI is writing a SWOT analysis of your solution.',
      'Patience pays off — a thorough assessment is coming.',
      'Finishing stage — almost done!',
    ],
  },
  sourceLabels: {
    writeLabel: 'Write solution',
    yourSolution: 'Your solution',
    aiEnhanced: 'AI-enhanced',
    humanPercent: '{{percent}}% human',
  },
  modal: {
    bgEnriching: 'AI is enriching the solution...',
    bgAnalyzing: 'AI is analyzing the solution...',
    matchFailedHttp: 'Mapping failed (HTTP {{status}})',
    matchEmpty: 'Mapping returned an empty response',
    matchFailed:
      'Mapping obstacles and opportunities failed: {{message}}. You can try again or continue without coverage assessment.',
    deleteFailed: 'Delete failed',
    saveFailed: 'Save failed',
    saveFailedGeneric: 'Save failed',
    matchIdentifyFailed:
      'Identifying obstacles and opportunities failed. You can continue without coverage assessment.',
    analysisFailed:
      'AI analysis failed: {{message}}. You can continue without analysis or try again.',
    unknownError: 'Unknown error',
    publishFailed: 'Publish failed',
    enrichFailed: 'AI enrichment failed',
    reanalyzeFailed:
      'Re-analysis failed: {{message}}. You can continue without analysis.',
    reanalyzeFailedGeneric: 'Re-analysis failed',
  },
  startView: {
    title: 'Time for solutions',
    subtitle:
      'You have explored future scenarios, built impact paths, identified pivot points, and analyzed obstacles and opportunities. Now it is time to propose concrete solutions.',
    labelPivot: 'pivot points',
    labelObstacle: 'obstacles',
    labelOpportunity: 'opportunities',
    nextCardTitle: 'Create solutions',
    nextCardSubtitle: 'Choose a pivot point and write a solution proposal',
    cta: "Let's go!",
  },
  pivotSelect: {
    pageTitle: 'Choose a pivot point',
    helperText: 'Pick a pivot point to attach solution proposals to.',
    emptyState: 'No pivot points yet. Create them in the Lenses step first.',
    unnamed: 'Untitled',
    solutionSingular: '{{count}} solution',
    solutionPlural: '{{count}} solutions',
    votes: 'Important · {{count}} teams',
  },
};

export const solutionComponentsSv = {
  listView: {
    backToPivots: 'Vridpunkter',
    pageTitle: 'Lösningar',
    addSolution: 'Lägg till lösning',
    pivotTag: 'Vridpunkt',
    emptyTitle: 'Inga lösningar ännu',
    emptyHint: 'Börja med att lägga till den första lösningen.',
    editTitleTooltip: 'Redigera rubrik',
    phaseWrite: 'Skriv',
    phaseCoverage: 'Hinder',
    phaseDone: 'Klar',
    stateAnalysing: 'Analyserar…',
    stateReady: 'Klar',
    ownBadge: 'Min',
    doneLabel: 'Klar',
    solutionGroupCountOne: '{{count}} lösning',
    solutionGroupCountMany: '{{count}} lösningar',
    viewByPivot: 'Per vridpunkt',
    viewVotingResults: 'Röstningsresultat',
    signInToVote: 'Logga in för att rösta på lösningar. Röstetal syns för alla.',
    vote: 'Rösta',
    removeVote: 'Ta bort röst',
    signInToVoteTitle: 'Logga in för att rösta',
    otherSolutions: 'Övriga lösningar',
    orphanDescOne: '{{count}} lösning utan vald vridpunkt',
    orphanDescMany: '{{count}} lösningar utan vald vridpunkt',
  },
  screen: {
    navPivots: 'Vändpunkter',
    navSolutions: 'Lösningar',
    navOverview: 'Översikt',
    allSolutions: 'Alla lösningar',
    loading: 'Laddar lösningsdata...',
    errorLoading: 'Fel vid laddning av data',
    noInstance: 'Ingen instans vald. Lägg till ?kid= eller ?instance= i URL:en.',
  },
  common: {
    cancel: 'Avbryt',
    delete: 'Ta bort',
    confirmDelete: 'Ja, ta bort',
    deleting: 'Tar bort...',
    close: 'Stäng',
    save: 'Spara',
    edit: 'Redigera',
    continue: 'Fortsätt →',
    saving: 'Sparar...',
    doneArrow: 'Klar →',
    solution: 'Lösning',
  },
  write: {
    placeholder: 'Skriv ett lösningsförslag...',
    enrichDone: 'Texten berikad!',
    enrichTooltip: 'Berika texten med AI',
    reEnrichTooltip: 'Ersätt aktuell AI-text',
    enrichBtn: 'AI-berika',
    reEnrichBtn: 'Skapa på nytt',
    enrichMessages: [
      'Hämtar forskningsdata...',
      'Analyserar lösningen...',
      'Berikar texten...',
      'Färdigställer...',
    ],
    matchingMessages: [
      'Sparar lösningen...',
      'Kartlägger hinder och möjligheter...',
      'AI identifierar vilka punkter din lösning svarar på...',
    ],
  },
  coverage: {
    noLensItems:
      'Inga hinder eller möjligheter har lagts till för denna vridpunkt ännu. Du kan gå vidare direkt till AI-analys.',
    matchingStatus: 'Kartlägger hinder och möjligheter…',
    matchingDone: 'Täckning kontrollerad!',
    matchingMessages: [
      'Kontrollerar linstäckning...',
      'Identifierar hinder och möjligheter...',
    ],
    analysisMessages: [
      'Sparar lösningen...',
      'Hämtar forskningsdata...',
      'Bedömer påverkan...',
      'Bedömer genomförbarhet...',
      'Bedömer innovativitet...',
      'Kontrollerar forskningsstöd...',
      'Skriver SWOT-analys...',
      'Analyserar linseffekter...',
      'Färdigställer helhetsbedömning...',
      'Nästan klart — en sista kontroll...',
      'Putsar de sista detaljerna...',
    ],
    estimatedTime: '20–60 sekunder',
    openBlockers: 'Öppna hinder',
    solutionCovers: 'Lösningen täcker',
    groupHandled: 'Hanterade av gruppen',
    itemsCount: '{{count}} punkter',
    notePlaceholder: 'Hur skulle er lösning kunna ta hänsyn till detta?',
    obstacleTag: 'hinder',
    opportunityTag: 'möjlighet',
    sufficientTag: 'tillräcklig',
    insufficientTag: 'otillräcklig',
    groupNotePrefix: 'Grupp:',
    aiPrefix: 'AI:',
  },
  done: {
    obstaclesOpportunities: 'Hinder & möjligheter',
    disclaimer:
      'AI-analysen bygger på forskningsdatabasen och en språkmodell. Den ersätter inte din expertis.',
    confirmDeletePublished:
      'Lösningen är redan analyserad och publicerad. Är du säker på att du vill ta bort den?',
    reanalyze: 'Analysera igen',
    aiWorking: 'AI arbetar…',
    analysisMessages: [
      'Sparar lösningen...',
      'Hämtar forskningsdata...',
      'Jämför forskningskällor...',
      'Identifierar lösningstaggar...',
      'Skriver SWOT-analys...',
      'Identifierar styrkor...',
      'Identifierar utvecklingsområden...',
      'Analyserar linseffekter...',
      'Bedömer hinderäckning...',
      'Skriver helhetsbedömning...',
      'Kontrollerar referenser...',
      'Färdigställer analysen...',
      'Sammanställer resultat...',
      'Nästan klart — en sista kontroll...',
      'Putsar de sista detaljerna...',
    ],
    estimatedTime: '1–2 minuter',
  },
  stepper: {
    write: 'Skriv lösning',
    coverage: 'Hinder & möjligheter',
    done: 'AI-analys',
    info: {
      write:
        'Skriv ditt lösningsförslag med egna ord. När du är klar kan du be AI berika texten med forskning. Efter detta steg väger vi hinder och möjligheter.',
      write_enriching:
        'AI berikar din text med forskning. Du kan fortsätta skriva eller gå till nästa steg.',
      write_enriched:
        'Texten berikad! Kontrollera ändringarna — din text är blå, AI-tillägg vita.',
      coverage:
        'Kontrollera hur din lösning svarar mot identifierade hinder och möjligheter. Du kan skriva ett svar för öppna punkter.',
      coverage_enriching:
        'AI-berikning pågår fortfarande. Hinder och möjligheter bygger på originaltexten.',
      coverage_matching: 'AI kontrollerar vilka hinder och möjligheter din lösning svarar på...',
      done_analyzing: 'AI analyserar din lösning — analysen visas här när den är klar.',
      done: 'Din lösning är klar och analyserad.',
    },
  },
  intro: {
    title: 'Skapa lösning',
    bodyWithPivotBefore: 'Du skapar ett lösningsförslag för vridpunkten ',
    bodyWithPivotAfter: '. Processen har tre steg:',
    bodyNoPivot: 'Du skapar ett lösningsförslag. Processen har tre steg:',
    bodyWithPivotAfter2: '. Processen har två steg:',
    bodyNoPivot2: 'Du skapar ett lösningsförslag. Processen har två steg:',
    start: 'Börja',
    step1Title: 'Skriv ett lösningsförslag',
    step1Desc:
      'Beskriv din lösning med egna ord. Den behöver inte vara perfekt — kärnidén är det viktigaste.',
    step1Ai: 'AI kan berika din text med forskning',
    step2Title: 'Hinder & möjligheter',
    step2Desc:
      'Kontrollera hur din lösning svarar mot identifierade hinder och möjligheter. Du kan skriva ett kort svar för öppna punkter.',
    step2Ai: 'AI identifierar vilka punkter din lösning svarar på',
    step3Title: 'Klar',
    step3Desc: 'Din lösning sparas och du ser resultaten när de är klara.',
    step3Ai: 'AI analyserar din lösning i bakgrunden',
  },
  analysisLoader: {
    title: 'AI analyserar din lösning',
    closeTitle: 'Stäng — analysen fortsätter i bakgrunden',
    closeAndNew: 'Stäng och lägg till en ny lösning',
    closeHint: 'Analysen fortsätter i bakgrunden — resultatet visas i listan.',
    closeBackground: 'Stäng — analysen fortsätter i bakgrunden',
    starting: 'Startar...',
    estimatedPrefix: 'Beräknad tid: {{time}}',
    warmSubtitles: [
      'Detta tar en stund — bra läge att stretcha.',
      'AI läser forskning och bedömer din lösning.',
      'Dags för kaffepaus — vi är snart tillbaka med resultat.',
      'AI går igenom forskningsdatabasen.',
      'Bra läge att titta ut genom fönstret.',
      'Analysen pågår — oroa dig inte, allt går framåt.',
      'AI jämför din lösning med tidigare forskningsresultat.',
      'En kort paus gör gott — vi tar hand om det här.',
      'Söker styrkor och utvecklingsområden.',
      'Att gå igenom forskningsdatabasen tar en stund.',
      'Resultat snart — analysen går bra.',
      'AI väger olika perspektiv.',
      'En bra lösning förtjänar en noggrann bedömning.',
      'AI går igenom hinder, möjligheter och linser.',
      'Nästan klart — färdigställer bedömningen.',
      'Forskningskällor genomgångna, sammanställer resultat.',
      'Gör en liten stretch — resultaten är snart klara.',
      'AI skriver en SWOT-analys av din lösning.',
      'Tålamod belönas — en grundlig bedömning kommer.',
      'Slutfas — nästan klart!',
    ],
  },
  sourceLabels: {
    writeLabel: 'Skriv lösning',
    yourSolution: 'Din lösning',
    aiEnhanced: 'AI-förbättrad',
    humanPercent: '{{percent}}% människa',
  },
  modal: {
    bgEnriching: 'AI berikar lösningen...',
    bgAnalyzing: 'AI analyserar lösningen...',
    matchFailedHttp: 'Kartläggning misslyckades (HTTP {{status}})',
    matchEmpty: 'Kartläggningen returnerade ett tomt svar',
    matchFailed:
      'Kartläggning av hinder och möjligheter misslyckades: {{message}}. Du kan försöka igen eller fortsätta utan täckningsbedömning.',
    deleteFailed: 'Borttagning misslyckades',
    saveFailed: 'Sparande misslyckades',
    saveFailedGeneric: 'Sparande misslyckades',
    matchIdentifyFailed:
      'Identifiering av hinder och möjligheter misslyckades. Du kan fortsätta utan täckningsbedömning.',
    analysisFailed:
      'AI-analys misslyckades: {{message}}. Du kan fortsätta utan analys eller försöka igen.',
    unknownError: 'Okänt fel',
    publishFailed: 'Publicering misslyckades',
    enrichFailed: 'AI-berikning misslyckades',
    reanalyzeFailed:
      'Om-analys misslyckades: {{message}}. Du kan fortsätta utan analys.',
    reanalyzeFailedGeneric: 'Om-analys misslyckades',
  },
  startView: {
    title: 'Dags för lösningar',
    subtitle:
      'Ni har utforskat framtidsbilder, byggt effektvägar, identifierat vridpunkter och analyserat hinder och möjligheter. Nu är det dags att föreslå konkreta lösningar.',
    labelPivot: 'vridpunkter',
    labelObstacle: 'hinder',
    labelOpportunity: 'möjligheter',
    nextCardTitle: 'Skapa lösningar',
    nextCardSubtitle: 'Välj en vridpunkt och skriv ett lösningsförslag',
    cta: 'Vi börjar!',
  },
  pivotSelect: {
    pageTitle: 'Välj vridpunkt',
    helperText: 'Välj en vridpunkt som lösningarna ska kopplas till.',
    emptyState: 'Inga vridpunkter ännu. Skapa dem först i Lins-steget.',
    unnamed: 'Namnlös',
    solutionSingular: '{{count}} lösning',
    solutionPlural: '{{count}} lösningar',
    votes: 'Viktig · {{count}} team',
  },
};
